import { isHoliday } from "nyse-holidays";

/**
 * Check if a date is a non-trading day (weekend or holiday)
 * @param {Date} date - The date to check
 * @returns {boolean} - True if the date is a non-trading day
 */
export function isNonTradingDay(date) {
  return date.getDay() === 0 ||
      date.getDay() === 6 ||
      isHoliday(date);
}

/**
 * Get the next trading day after the given date
 * @param {Date} date - The starting date
 * @returns {Date} - The next trading day
 */
export function getNextTradingDay(date) {
  const nextDay = new Date(date);
  nextDay.setDate(nextDay.getDate() + 1);

  let lookbackCount = 0;
  while (isNonTradingDay(nextDay) && lookbackCount < 10) {
      nextDay.setDate(nextDay.getDate() + 1);
      lookbackCount++;
  }

  return nextDay;
}

/**
 * Get the previous trading day before the given date
 * @param {Date} date - The starting date
 * @returns {Date} - The previous trading day
 */
export function getPreviousTradingDay(date) {
  const prevDay = new Date(date);
  prevDay.setDate(prevDay.getDate() - 1);

  let lookbackCount = 0;
  while (isNonTradingDay(prevDay) && lookbackCount < 10) {
      prevDay.setDate(prevDay.getDate() - 1);
      lookbackCount++;
  }

  return prevDay;
}

/**
 * Adjust signal set dates to the next trading day
 * @param {Array} signalSets - Array of signal set objects with date property
 * @returns {Array} - Array of signal sets with adjusted dates
 */
export function adjustSignalSetDates(signalSets) {
  return signalSets.map(signalSet => {
      const adjustedSignalSet = { ...signalSet };
      const signalDate = new Date(adjustedSignalSet.date);

      // Always move to the next trading day
      adjustedSignalSet.date = getNextTradingDay(signalDate).getTime();

      return adjustedSignalSet;
  });
}

